// extracted by mini-css-extract-plugin
export default {"imageWrapper":"zK-z","twoColumnImage":"AK-z"};